var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card card--shadow pa-0 h-100 overflow-hidden"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.image
    }
  }), _c('div', {
    staticClass: "pa-12 pa-md-24 text-center"
  }, [_c('p', {
    staticClass: "page-text font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }